import React from 'react';
import PropTypes from 'prop-types';

/**
 * A title component
 * @param {{
 *   className?: string,
 * }} props
 * @return {JSX.Element}
 * @constructor
 */
const Title = (props) => {
  const {
    children,
    className,
  } = props;

  return (
    <div className={className}>
      <h2 className="font-header text-xl font-normal leading-sm">{children}</h2>
      <hr className="w-[50px] mb-3 mt-1.5 ml-0 border-t-[3px] border-green"/>
    </div>
  );
};

Title.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  className: PropTypes.string,
};

export { Title };
